import {
  B2bIndividualOperationInitiatorValues,
  B2bIndividualOperationTypeValues,
  GetB2bIndividualOperationOneResponse,
  GetB2bIndividualOperationOrderResponse,
} from '@Common/types/bo/b2b/individual_operations';

export const b2bIndividualOperationsTranslations = {
  list: {
    empty: 'No individual operations found',
  },
  tabs: {
    all: {
      label: 'All',
    },
  },
  show: {
    title: 'Details',
    orders_title: 'Breakdown per eligible order',
    orders_empty: 'The associated orders are not yet available',
  },
  fields: {
    id: 'ID',
    side: 'Direction',
    equipment: 'Equipment',
    type: 'Type',
    execution_date: 'Execution Date',
    reference_period: 'Reference Period',
    status: 'Status',
    cancellation_reason: 'Cancellation reason',
    cancellation_initiator: 'Cancellation initiator',
    social_status: 'Social Status',
    total_gross_amount: 'Total Gross Amount',
    total_entry_fee_employee_amount: 'Entry fees (employees)',
    total_net_amount: 'Total Net Amount',
    isin: 'ISIN',
    instrument_id: 'Instrument ID',
    gross_amount: 'Gross Amount',
    net_amount: 'Net Amount',
    entry_fee_employee_amount: 'Entry fees (employees)',
    created_at: 'Created at',
    updated_at: 'Updated at',
    firstname: 'First Name',
    lastname: 'Last Name',
    registration_number: 'Registration Number',
    availability_date: 'Availability Date',
    identifier: 'Identifier',
    nav_date: 'NAV Date',
    nav: 'NAV',
    tax_residence_code: 'Tax residence code',
    instrument_name: 'Investment or payment support',
    user_currency_amount_input: 'Net invested amount',
    filled_quantity: 'Filled quantity',
    entry_fee_company_amount: 'Entry fees (company)',
    tax_amount: 'Social contribution amount',
    linked_order_id: 'Linked Order ID',
    individual_operation_id: 'Individual operation ID',
    operation_type: 'Operation type',
    mc_gross_amount: 'Matching contribution gross amount',
    mc_net_amount: 'Matching contribution net amount',
    mc_entry_fee_employee_amount: 'Matching contribution entry fee (employee)',
    mc_entry_fee_company_amount: 'Matching contribution entry fee (company)',
    mc_tax_info: 'Matching contribution tax info',
    mc_filled_quantity: 'Matching contribution filled quantity',
    mc_user_currency_amount_input: 'Matching contribution user currency amount input',
    mc_individual_operation_id: 'Matching contribution individual operation ID',
    plan_type: 'Plan type',
    b2b_company_plan_id: 'Plan ID',
    b2b_employee_id: 'Employee ID',
    b2b_company_id: 'Company ID',
    b2b_contract_id: 'Contract ID',
    user_id: 'User ID',
    initiator: 'Initiator',
    bo_user_email: 'Backoffice user',
    b2b_recurring_investment_id: 'Recurring Investment ID',
    is_recurring_investment: 'Is recurring investment',
    b2b_correction_id: 'Cancellation correction ID',
    b2b_correction_status: 'Cancellation correction status',
    has_matching_contribution: 'Has a matching contribution',
    from_created_at: 'Created from',
    to_created_at: 'Created until',
  } satisfies Record<
    | keyof GetB2bIndividualOperationOneResponse
    | keyof GetB2bIndividualOperationOrderResponse
    | 'is_recurring_investment'
    | 'from_created_at'
    | 'to_created_at',
    string
  >,
  initiator: {
    backoffice: 'Backoffice',
    user: 'User',
  } satisfies Record<(typeof B2bIndividualOperationInitiatorValues)[number], string>,
  type: {
    employee_voluntary_deposit: 'Employee Voluntary Deposit',
    company_voluntary_deposit: 'Company Voluntary Deposit',
    arbitrage: 'Arbitrage',
    collective_arbitrage: 'Collective Arbitrage',
    rebalancing: 'Rebalancing',
    withdrawal: 'Withdrawal',
    transfer_in: 'Transfer In',
    transfer_out: 'Transfer Out',
    participation: 'Profit-sharing Bonus',
    profit_sharing: 'Incentive Bonus',
    value_sharing_bonus: 'Value-sharing Bonus',
    unused_vacation_days: 'Time Savings Account Bonus',
    voluntary_deposit_campaign: 'Voluntary Deposit Campaign',
    matching_contribution: 'Matching Contribution',
    corporate_action: 'Corporate Action',
    ccb_matured_election: 'Legal Deadline',
    withdrawal_at_maturity: 'Maturity payout',
    capital_increase: 'Capital Increase',
  } satisfies Record<(typeof B2bIndividualOperationTypeValues)[number], string>,
};
